'use client';

import { usePathname } from 'next/navigation';
import Link from 'next/link';
import Button from 'components/common/Button';
import TabItem from 'components/common/TabItem';
import { LandingHeader } from 'components/landing/LandingHeader';
import { RebaseEcoModal } from 'components/rebates';
import { BUTTON_TEXT } from 'utils/constants';
import { useDeviceDetect } from '@/utils/useDeviceDetect';
import { useStore } from 'zustand';
import { useMapStore } from '@/stores/map/mapStore';
import WhereToBuyBtn from '@/components/button/where-to-buy-btn';

interface NavItem {
  path: string;
  label: string;
}

export function LayoutHeader() {
  const isMobile = useDeviceDetect();
  const { setModalMapOpen } = 
  useStore(useMapStore, (state) => ({
    setModalMapOpen: state.setModalMapOpen,
  }));
  const pathname = usePathname();
  const slug = 'universal-series';
  const urlPrefix = `/product/${slug}`;

  const navItems: NavItem[] = [
    {
      path: `${urlPrefix}`,
      label: 'Overview',
    },
    {
      path: `${urlPrefix}/specification`,
      label: 'Specs',
    },
    {
      path: `${urlPrefix}/compare`,
      label: 'Compare',
    },
    // {
    //   path: `${urlPrefix}/use-cases`,
    //   label: 'Use Cases',
    // },
  ];

  return (
    <LandingHeader
      title='Universal Series'
      rebateContent={<RebaseEcoModal product={slug} id='1' />}
      contentRight={
        <WhereToBuyBtn isMobile={isMobile} setMapOpen={setModalMapOpen} />
      }
    >
      {navItems.map((item: NavItem, index: number) => {
        return (
          <TabItem
            key={index}
            isActive={pathname === item.path}
            className='py-0'
          >
            <Link
              href={item.path}
              title={item.label}
              className='flex h-full flex-row items-center justify-center'
            >
              {item.label}
            </Link>
          </TabItem>
        );
      })}
    </LandingHeader>
  );
}
